<template>
	<div class="row" v-if="hasDrone">
		<div class="col">
			<div class="h4 mt-3">
				<span class="h4">Drone</span>
				<span class="float-right lead">{{drone.Name}} ({{drone.Type}} {{drone.Level}})</span>
			</div>
			<div class="table-responsive">
				<table class="table table-sm table-bordered table-striped mb-0">
					<tbody>
						<tr>
							<td><strong>HP</strong> <small class="text-muted">Health</small></td>
							<td style="width: 4em;"></td>
							<td style="text-align:right;">{{stats.HP}}</td>
						</tr>
						<tr v-if="stats.RP">
							<td><strong>RP</strong> <small class="text-muted">Resolve</small></td>
							<td style="width: 4em;"></td>
							<td style="text-align:right;">{{stats.RP}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<ul class="list-group list-group-flush">
				<li class="list-group-item p-0 bt-0">
					<span class="lead">Defense</span>
					<ul class="list-inline">
						<li class="list-inline-item"><strong>EAC</strong> {{stats.AC + parseInt(drone.EAC)}}</li>
						<li class="list-inline-item"><strong>KAC</strong> {{stats.AC + parseInt(drone.KAC)}}</li>
						<li class="list-inline-item"><strong>Fort</strong> {{ (drone.GoodSave == "Fortitude" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
						<li class="list-inline-item"><strong>Ref</strong> {{ (drone.GoodSave == "Reflex" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
						<li class="list-inline-item"><strong>Will</strong> {{ (drone.GoodSave == "Will" ? stats.GoodSave : stats.PoorSave)|bonus }}</li>
					</ul>
				</li>
				<li class="list-group-item p-0">
					<span class="lead">Offense</span>
					<ul class="list-inline">
						<li class="list-inline-item"><strong>Speed</strong> {{drone.Speed}}</li>
						<li class="list-inline-item"><strong>Melee</strong> {{(abilityMod(drone.AbilityScores.Strength)+stats.BAB)|bonus}}</li>
						<li class="list-inline-item"><strong>Ranged</strong> {{(abilityMod(drone.AbilityScores.Dexterity)+stats.BAB)|bonus}}</li>
					</ul>
				</li>
				<li class="list-group-item p-0">
					<span class="lead">Statistics</span>
					<div>
						<span v-for="(score, ability) in drone.AbilityScores" :key="ability">
							<strong>{{ability|abbr}}</strong> {{score}} ({{abilityMod(score)|bonus}})
						</span>
					</div>
					<div>
						<strong>Skills</strong> {{drone.Skills}}
					</div>
					<div>
						<ul class="list-inline d-inline">
							<li class="list-inline-item"><strong>Mods</strong></li>
							<li class="list-inline-item" v-for="(mod, index) in drone.Mods" :key="'droneMods-'+index">{{mod}}</li>
						</ul>
					</div>
					<div>
						<ul class="list-inline d-inline">
							<li class="list-inline-item"><strong>Feats</strong></li>
							<li class="list-inline-item" v-for="(feat, index) in drone.Feats" :key="'droneFeats-'+index">{{feat}}</li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	methods: {
		abilityMod: function(score) {
			return Math.floor((score - 10) / 2)
		},
		percentage: function(fraction, whole){
			return Math.round( (fraction/whole)*100 )+'%';
		},
		spellConcat: function(spell) {
			var name = spell.replace(/\(.*\)/, '').replace(/[^a-zA-Z-]+/g, '');
			return name;
		}
	},
	computed: {
		drone: function() {
			return this.$store.state.Character.Levels[ this.$store.getters['currentLevel'] ].Drone
		},
		current: function() {
			return this.$store.state.Character.Current.Drone
		},
		stats: function() {
			return this.$store.getters['character/drones/stats']
		},
		HP: function() {
			return this.current.Points.Hit
		},
		RP: function() {
			return this.current.Points.Resolve
		},
		...mapGetters('character/drones',[
			'hasDrone',
		])
	},
}
</script>

<style scoped>

</style>